// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"fcc0123d","453":"1fe6c1e1","623":"c603ce16","832":"6829c4d7"}[chunkId] + ".chunk.js";
};